import styled from "styled-components";

interface IContainer{
    isRead: boolean;
    color: "green" | "red" | "yellow" | "blue";
}

const ContainerNotificationCard = styled.div<IContainer>`
    display: flex;
    align-items: center;

    background: transparent;
    transition: 200ms ease;
    height: 72px;
    min-height: 72px;
    color: var(--default-color-font);

    margin: 2px 0;

    ${(props) => props.isRead ? `
        border-left: 4px solid var(--accordion-color); 
        >div:first-child { 
            opacity: 0.8;
        }
        >div:last-child,
        >a:last-child { 
            opacity: 0.5;
        }
    ` : `
        border-left: 4px solid var(--${props.color}); 
    `}

    &:hover{
        cursor: pointer;
        background: var(--accordion-color);
        >div:first-child {
            opacity: 1;
        }
        >div:last-child,
        >a:last-child{
            opacity: 1;
            span.title-message-notification{
                font-weight: bold;
            }
        }
        >a:last-child:hover{
            text-decoration: underline;
        }
    }
`;

export const MessageContent = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    padding: 4px 0 4px 16px;
    >span{
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        word-break: break-word;
        display: -webkit-box;
        font-size: 0.83rem;
        &.business-group-div{
            display:flex;
            align-items:center;
            color: var(--input-font-color);
            font-size: 0.625rem;
            svg{
                margin-right: 4px;
            }
        }
    }
    >small{
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
        overflow: hidden;
        word-break: break-word;
        display: -webkit-box;
        font-size: 0.7rem;
        color: var(--input-font-color);
        svg.app-icons{
            margin-right: 2px;
        }
    }
`;

export const MessageListContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: calc(100% - 72px);
    overflow-x: hidden;
    overflow-y: auto;
`;

export const ButtonsContainer = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    font-size: 0.925rem;
    color: var(--purple);
    padding: 1rem;
    transition: 200ms ease;

    &:hover{
        background: var(--accordion-color);
        cursor: pointer;
        text-decoration: underline;
    }
`;

export const NotificationIconContainer = styled.div`
    display: flex;
    align-items: center;
    svg.icon-mark-as-read{
        position: absolute;
        right: -4px;
        bottom: -8px;
        background: var(--input-background-color);
        z-index: 1;
        border-radius: 50%;
        display: flex;
        width: 18px;
        height: 18px;
    }
`;

export const HeaderNotifications = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    >svg{
        border: 0;
        cursor: pointer;
        background: transparent;
        min-width: 30px;
        color: var(--close-icon);
        text-shadow: 0 1px 0 var(--close-icon-shadow);
        opacity: .2;
        transition: 300ms ease;
        &:hover{
            opacity: 0.6;
        }
    }
`;

export const SystemImg = styled.img`
    width: 42px;
    height: 42px;
    margin: 0 4px;
`;

export default ContainerNotificationCard;
